<script>
import { getCurrentInstance, onMounted, ref } from 'vue';
import commonFn from '@/commons/commonFunction';
import MsCheckbox from '../checkbox/MsCheckbox.vue';
import { useStore } from 'vuex';

export default {
  components: { MsCheckbox },
  props: {
    title: String,
    width: {
      type: Number,
      default: 400,
    },
    message: [String, Array],
    type: {
      type: Number,
      default: 0,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    textBtn: {
      type: String,
      default: null,
    },
    /**
     * Thêm optionList cho message có dạng chọn
     * tbngoc 22.07.2022
     */
    optionList: {
      type: Array,
      default: null,
    },
    customLabelIsShowMessage: {
      type: String,
      default: null,
    },

    /**
     * Object custom text của button VD: showConfirmValidate(message, title, width, customTextButton)
     */
    customTextButton: {
      type: Object,
      default: { Yes: 'Có', No: 'Không' },
    },
  },

  setup(props) {
    const { proxy } = getCurrentInstance();
    const store = useStore()
    const data = store.state.dialog.data;
    //console.log(data)
    // Khi gọi hàm $close truyền đủ 2 tham số thì không cần khai báo hàm hày
    // function returnValue() {
    //   return true;
    // }

    const IsShowMessage = ref(true); // Dùng cho việc ẩn hiện thông báo sinh chứng từ
    const option = ref(1); // Option trả về
    onMounted(() => {
      //focus button
      commonFn.focusFirstControl(proxy.$refs['msg']);
    });

    function escPress(e, close) {
      e.preventDefault();
      close(this, null);
    }

    return {
      // returnValue,
      escPress,
      IsShowMessage,
      option,
    };
  },
};
</script>

<template>
  <!-- Đợi thiết kế chỉnh lại style sau -->
  <div class="msg-box" @keydown.esc="escPress($event, $close)">
    <div class="msg-center" ref="msg" :style="{ width: width + 'px' }">
      <div class="msg-title">{{ title }}</div>
      <div
        v-if="!hideClose"
        class="msg-close icon24 close"
        @click="$close(this, type == 2 ? null : false)"
      ></div>
      <div class="msg-message">
        <template v-if="Array.isArray(message)">
          <div
            class="msg-item"
            v-for="(item, i) in message"
            :key="i"
            v-html="item"
          ></div>
        </template>

        <div class="msg-item" v-else v-html="message"></div>
        <!-- confirm không hiện lại popup này lần sau -->
        <div class="mt-1" v-if="type == 7">
          <ms-checkbox
            :label="customLabelIsShowMessage || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          ></ms-checkbox>
        </div>

        <div class="flex mt-1" v-if="type == 9">
          <ms-radio
            v-for="(item, index) in optionList"
            :key="index"
            :label="item.text"
            name="rdnameMessageBox"
            :keyValue="item.value"
            v-model="option"
            class="mb-2"
          />
          <div class="hr-row"></div>
          <ms-checkbox
            :label="customLabelIsShowMessage || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          ></ms-checkbox>
        </div>
      </div>

      <!-- alert: info/warning -->
      <div
        class="msg-buttons flex-center"
        v-if="type == this.$ms.constant.MessageBoxType.confirm_Info_Warning"
      >
        <button @click="$close(this, null)" class="msg-btn btn primary">
          {{ $t('i18nComponent.MessageBox.Accept') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div
        class="msg-buttons flex-row"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Yes_No"
      >
        <div class="flex"></div>
        <button
          @click="$close(this, false)"
          class="msg-btn btn secondary-outline"
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <button @click="$close(this, true)" class="msg-btn btn primary">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
      </div>
      <!-- confirm yes_no_cancel-->
      <div
        class="msg-buttons flex-row"
        v-else-if="
          type == this.$ms.constant.MessageBoxType.confirm_Yes_No_Cancel
        "
      >
        <button
          @click="$close(this, null)"
          class="msg-btn btn secondary-outline"
        >
          {{ $t('i18nComponent.MessageBox.Cancel') }}
        </button>
        <div class="flex"></div>
        <button
          @click="$close(this, false)"
          class="msg-btn btn secondary-outline"
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <button @click="$close(this, true)" class="msg-btn btn primary">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
      </div>
      <!-- confirm delete-->
      <div
        class="msg-buttons flex-row"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Delete"
      >
        <div class="flex"></div>
        <button
          @click="$close(this, false)"
          class="msg-btn btn secondary-outline"
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <button @click="$close(this, true)" class="msg-btn btn primary">
          {{ $t('i18nComponent.MessageBox.Delete') }}
        </button>
      </div>
      <!-- confirm Đóng -->
      <div
        class="msg-buttons flex-center"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Close"
      >
        <button @click="$close(this, null)" class="msg-btn btn primary">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div class="msg-buttons flex-row" v-else-if="type == 5 || type == 7">
        <div class="flex"></div>
        <button
          @click="
            $close(
              this,
              type == 7
                ? {
                    answer: false,
                    IsShowMessage: IsShowMessage,
                  }
                : false
            )
          "
          class="msg-btn btn secondary-outline"
        >
          {{ customTextButton.No }}
        </button>
        <button
          @click="
            $close(
              this,
              type == 7
                ? {
                    answer: true,
                    IsShowMessage: IsShowMessage,
                  }
                : true
            )
          "
          class="msg-btn btn primary"
        >
          {{ customTextButton.Yes }}
        </button>
      </div>

      <div class="msg-buttons flex-center" v-if="type == 6">
        <button @click="$close(this, true)" class="msg-btn btn primary">
          {{ textBtn }}
        </button>
      </div>

      <div class="msg-buttons flex-row" v-else-if="type == 8">
        <div class="flex"></div>
        <button
          @click="$close(this, false)"
          class="msg-btn btn secondary-outline"
        >
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
        <button @click="$close(this, true)" class="msg-btn btn primary">
          Xem phát sinh
        </button>
      </div>

      <div class="msg-buttons flex-row" v-else-if="type == 9">
        <div class="flex"></div>
        <button
          @click="
            $close(this, {
              answer: false,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
          class="msg-btn btn secondary-outline"
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <button
          @click="
            $close(this, {
              answer: true,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
          class="msg-btn btn primary"
        >
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsMessageBox.scss';
</style>
